import { fromRef } from '../observable/fromRef';
export function createObjectSnapshotChanges(query, scheduler) {
    return function snapshotChanges() {
        return fromRef(query, 'value', 'on', scheduler);
    };
}
//# sourceMappingURL=snapshot-changes.js.map